module.exports = __webpack_public_path__ + "static/grain-94b7f3750c1024bc7d50f6bdc940dc55.png";